import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { BADGE_COLORS, getBadgeStyles } from "../../../../components/ui/badgeColors";
import { formatearFechaHora } from "../../helpers/fechas";

// Datos secundarios de la incidencia, en el orden en que se muestran al pie
const DETALLES = [
    { campo: "causa", label: "Causa" },
    { campo: "referencia", label: "Ref." },
    { campo: "usuario", label: "Registrada por" },
    { campo: "entidadAfectada", label: "Afecta a" }
];

const ESTILO_CHIP = { height: 20, fontSize: 10 };

/**
 * Ficha de una incidencia de MSoft del seguimiento de una recogida.
 * La API la entrega ya resumida ({fecha, tipo, situacion, causa, descripcion,
 * referencia, usuario, entidadAfectada}, campos vacíos a null).
 *
 * DECISION: tipo y situación son categorías de MSoft, no estados nuestros, así que
 * van en INDIGO y GRAY en vez de los colores con semántica de estado.
 */
const IncidenciaRecogida = ({ incidencia }) => {
    // Formato antiguo: texto plano
    if (typeof incidencia === "string") {
        return <Typography sx={{ fontSize: { xs: 12, sm: 13 }, color: "#212529" }}>{incidencia}</Typography>;
    }

    const { fecha, tipo, situacion, descripcion } = incidencia || {};
    const detalles = DETALLES.filter(({ campo }) => incidencia?.[campo]);

    return (
        <Box
            sx={{
                p: { xs: 1, sm: 1.25 },
                borderRadius: 1,
                border: "1px solid #e9ecef",
                backgroundColor: "#f8f9fa"
            }}
        >
            <Stack direction="row" alignItems="center" flexWrap="wrap" sx={{ gap: 0.75, mb: descripcion ? 0.5 : 0 }}>
                <Typography sx={{ fontSize: { xs: 11, sm: 12 }, fontWeight: 600, color: "#495057" }}>
                    {formatearFechaHora(fecha)}
                </Typography>
                {tipo && <Chip label={tipo} size="small" sx={getBadgeStyles(BADGE_COLORS.INDIGO, ESTILO_CHIP)} />}
                {situacion && (
                    <Chip label={situacion} size="small" sx={getBadgeStyles(BADGE_COLORS.GRAY, ESTILO_CHIP)} />
                )}
            </Stack>

            {descripcion && (
                <Typography sx={{ fontSize: { xs: 12, sm: 13 }, color: "#212529" }}>{descripcion}</Typography>
            )}

            {detalles.length > 0 && (
                <Typography sx={{ fontSize: { xs: 11, sm: 12 }, color: "#6c757d", mt: 0.5 }}>
                    {detalles.map(({ campo, label }) => `${label}: ${incidencia[campo]}`).join(" · ")}
                </Typography>
            )}
        </Box>
    );
};

export default IncidenciaRecogida;
